import { type ReactNode } from 'react';
import { Spinner } from '../Spinner/Spinner';
import './Button.css';

interface ButtonProps {
  children: ReactNode;
  variant?: 'filled' | 'outline' | 'danger' | 'modern';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
}

export function Button({
  children,
  variant = 'filled',
  size = 'md',
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  onClick,
}: ButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      className={`app-btn btn-${variant} btn-${size} ${loading ? 'btn-loading' : ''} ${className}`}
      disabled={isDisabled}
      onClick={onClick}
    >
      {loading ? (
        <span className="btn-spinner-content">
          <Spinner size="sm" variant={variant === 'filled' || variant === 'modern' ? 'light' : 'brand'} />
          <span className="btn-spinner-text">{children}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}
